import ExamenPreviewResult from '@/views/consultations/en-cours/examen-para/examen-preview-result'
import ImagerieRegistre from '@/components/imagerie-registre/index.vue'

export default {
    name: 'registre',
    components: { ExamenPreviewResult, ImagerieRegistre },
    data() { return { result_preview: {}, result_toggler: 0, info_resultat: {} } },
    computed: {
        activeRole() { return this.$store.getters.activeRole || {} },
        user_info() { const user = this.$store.getters.authInfo || {}; return { id: user.id, nom: user.name, titre: user.titre } }
    },
    methods: {
        previewResultExamen(group, row) {
            this.result_preview = { type_examen_nom: group.type_examen, type_examen_id: group.type_examen_id, resultat: row.resultat, interpretation: row.interpretation }
            this.info_resultat = row
            this.result_toggler++
        },
        refresh() { this.$refs.registry.refresh() }
    }
}
